export default __webpack_public_path__ + "static/media/DownloadAppThumbnail.8953f14d.png";